// extracted by mini-css-extract-plugin
module.exports = {"Container":"sendBox_Container__1V8qX","Depo":"sendBox_Depo__1ZL9b","Date":"sendBox_Date__ZuWc3","Transferd":"sendBox_Transferd__1uKUC","Deposit":"sendBox_Deposit__1teUA"};